module.exports = __webpack_public_path__ + "img/trade.f3d10912.svg";